import script from "./MapPagination.vue?vue&type=script&lang=ts&setup=true"
export * from "./MapPagination.vue?vue&type=script&lang=ts&setup=true"

import "./MapPagination.vue?vue&type=style&index=0&id=3e71ce37&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e71ce37"]])

export default __exports__